import { OptionalProperty } from '../../../utils/value.js';
import * as Ruleset from '../../methods/set.js';
import { RuleId } from '../../values/index.js';
const ComboListFix = (combos, styles) => {
    return combos.reduce((newCombos, p, index) => {
        const props = Combo.Fix(p, styles);
        if (props === null)
            return newCombos;
        const element = styles.find((s) => s.details.id === props.refId);
        const defaultComboExists = combos.find(({ isDefault, refId }, i) => {
            // Not comparing with the combo itself.
            if (i === index)
                return false;
            const comboElement = styles.find((s) => s.details.id === refId);
            if (!comboElement)
                return false;
            // Check that they exist in the same collection.
            if (element.details.collectionId === comboElement.details.collectionId) {
                return newCombos[i] ? newCombos[i].isDefault : isDefault;
            }
        });
        return [...newCombos, { ...props, isDefault: !defaultComboExists }];
    }, []);
};
export const NormalizeCombo = (props = {}) => {
    if (!props.refId || !props.id)
        return null;
    return {
        id: RuleId(props.id),
        refId: RuleId(props.refId),
        fillId: RuleId(props.fillId),
        decorationId: RuleId(props.decorationId),
        spacingId: RuleId(props.spacingId),
        typographyId: RuleId(props.typographyId),
        paletteId: RuleId(props.paletteId),
        isDefault: Boolean(props.isDefault)
    };
};
export const Combo = (props = {}) => NormalizeCombo(props);
Combo.Fix = (props, styles) => {
    const refId = OptionalProperty(props.refId, (id) => styles.some((s) => (s.type == 'block' || s.type == 'text' || s.type == 'inline') && s.details.id == id), null);
    const element = Ruleset.findById(styles, refId);
    const collection = Ruleset.findById(styles, element === null || element === void 0 ? void 0 : element.details.collectionId);
    const getComboRuleId = (id, type) => {
        const allIdsForType = Ruleset.filterByType(styles, type).map((s) => s.details.id);
        // @ts-ignore
        let elementRulesIds = element.props[type + 'Ids'];
        if (!elementRulesIds) {
            elementRulesIds = [Ruleset.findBlankId(styles, type)];
        }
        if (elementRulesIds.length === 0) {
            elementRulesIds = allIdsForType;
        }
        return OptionalProperty(id, (id) => elementRulesIds.includes(id), elementRulesIds[0]);
    };
    if (!element || !collection)
        return null;
    return {
        ...props,
        fillId: getComboRuleId(props.fillId, 'fill'),
        decorationId: getComboRuleId(props.decorationId, 'decoration'),
        spacingId: getComboRuleId(props.spacingId, 'spacing'),
        typographyId: getComboRuleId(props.typographyId, 'typography'),
        paletteId: getComboRuleId(props.paletteId, 'palette')
    };
};
export const Props = (props = {}) => ({
    blocks: Array.from(props.blocks || [])
        .map(Combo)
        .filter(Boolean),
    inlines: Array.from(props.inlines || [])
        .map(Combo)
        .filter(Boolean),
    texts: Array.from(props.texts || [])
        .map(Combo)
        .filter(Boolean)
});
export const validate = () => true;
export const fix = ({ blocks, texts, inlines }, styles) => ({
    blocks: ComboListFix(blocks, styles),
    inlines: ComboListFix(inlines, styles),
    texts: ComboListFix(texts, styles)
});
export const label = 'Theme';
export const type = 'theme';
export const category = 'concept';
//# sourceMappingURL=theme.js.map